import React from 'react';
import type { AgentOption } from '../types';
import pointsIcon from '@/assets/pointsicon.svg';

/**
 * 积分消耗徽标（V1 parity：index.tsx 右下角 currentAgent.points 显示 `-{points}`，
 * labelValue===2 时右上角叠「限时免费」标签）。
 * currentAgent 由 index.tsx 从 config 的 tag 节点 text 反查 agentOptions 派生（与 V1 一致）。
 * points 为 undefined/null 时不渲染（普通对话、无智能体场景）。
 */
export const PointsBadge: React.FC<{ currentAgent?: AgentOption }> = React.memo(
  ({ currentAgent }) => {
    const points = currentAgent?.points;
    if (points === undefined || points === null) return null;
    return (
      <div className="rte-points-badge" style={{ position: 'relative' }}>
        <img
          src={pointsIcon}
          alt=""
          aria-hidden="true"
          style={{ marginRight: '4px', width: '16px', height: '16px' }}
        />
        <span style={{ fontSize: '14px', lineHeight: '26px' }}>
          -{String(Number(points) * 16)}
        </span>
        {currentAgent?.labelValue === 2 && (
          <div className="rte-limited-free-badge">
            <span className="rte-limited-free-text">限时免费</span>
          </div>
        )}
      </div>
    );
  },
);
PointsBadge.displayName = 'PointsBadge';
